import { useEffect } from 'react';
import { useTestStore } from '../store/testStore';
import { migrateHistoryEntries } from '../utils/historyMigration';

/**
 * This hook migrates any test history entries that don't have dates.
 * It should be used in the top-level component of the application.
 */
export const useMigrateTestHistory = () => {
  const { history } = useTestStore();
  
  useEffect(() => {
    if (history && history.length > 0) {
      // Check if any history entries are missing the date property
      const needsMigration = history.some(entry => !entry.date || !entry.id);
      
      if (needsMigration) {
        console.log('Migrating test history entries to include dates and IDs');
        const migratedHistory = migrateHistoryEntries(history);
        
        // Update the store with the migrated history
        // We're accessing the internal state here, which is not ideal
        // but necessary for this migration
        useTestStore.setState({ history: migratedHistory });
      }
    }
  }, [history]);
  
  return null;
};

export default useMigrateTestHistory;